import React from "react"
import { graphql } from "gatsby" // highlight-line
import Layout from "../components/layout"
import NewsSplash from '../../static/img/splash-events-2021.jpg'
var dateFormat = require('dateformat');
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import parse from 'html-react-parser';

export default function NewsEvent({ pageContext }) {
  const {data} = pageContext;
  if(
    Object.keys(data).length>0
  ){
    return (
      <Layout className="news-page">
         <div
              className="splash jumbotron"
              style={{ minHeight: '400px', marginBottom: '0px', backgroundImage:`url(${NewsSplash})`, backgroundSize:'cover', backgroundPosition: 'center center' }}
         >
              <h1 className="text-white text-center wow fadeInDown">NEWS & EVENTS</h1>
         </div>
         <div className="container-fluid container-news pt-4 pb-4">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <nav aria-label="breadcrumb">
                 <ol className="breadcrumb">
                   <li className="breadcrumb-item"><a href="/" className="text-primary">Home</a></li>
                   <li className="breadcrumb-item"><a href="/news-events" className="text-primary">News &amp; Events</a></li>
                   <li className="breadcrumb-item active" aria-current="page">{data.title}</li>
                 </ol>
               </nav>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="media">
                  <div className="media-body">
                    <h2 className="text-left text-primary mt-2 mb-0">{data.title}</h2>
                    <h3 className="text-dark mt-2 mb-0">{data.type}</h3>
                    <h5 className="text-left text-light mt-0 mb-4"><FontAwesomeIcon icon="calendar"></FontAwesomeIcon> {dateFormat(data.date, 'mediumDate')}</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 news-events-body">{data.thumbnail&&data.thumbnail.length > 0 && <img alt={data.title} className="float-right ml-4" src={data.thumbnail[0].url} />}{parse(data.details)}</div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }else{
    return null;
  }
}
